var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThumbUpFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5724 1.34377C11.8571 1.30909 12.1313 1.36116 12.3952 1.50002C12.6591 1.63891 12.8537 1.83353 12.9787 2.08352C13.1036 2.33345 13.1311 2.59038 13.0617 2.85419L12.1242 6.66685H17.4993C17.9438 6.66685 18.333 6.83319 18.6663 7.16653C18.9996 7.49984 19.166 7.88912 19.166 8.33352V10.0002C19.166 10.0974 19.1523 10.2017 19.1245 10.3127C19.0967 10.4237 19.0685 10.528 19.0407 10.6252L16.5407 16.5C16.4157 16.7777 16.2073 17.0136 15.9157 17.208C15.6241 17.4024 15.3188 17.5002 14.9993 17.5002H3.33268C2.8744 17.5002 2.48229 17.3366 2.15592 17.0103C1.82958 16.6839 1.66606 16.2918 1.66602 15.8335V8.33352C1.66602 7.87519 1.82954 7.48234 2.15592 7.15595C2.48225 6.82976 2.87449 6.66685 3.33268 6.66685H5.83268L10.8327 1.70836C11.041 1.50002 11.2877 1.3785 11.5724 1.34377Z",
    fill: "#0D61BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbUpFilled);
export default __webpack_public_path__ + "static/media/icon-thumb-up-filled.28be612dff0534d20146cfa93363eef1.svg";
export { ForwardRef as ReactComponent };